jQuery(function () {
    var header = jQuery(".site-header");
    var html = jQuery("html");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            header.addClass("wm-floatingNav");
            html.addClass("has-scrolled-down");
        }
        else {
            header.removeClass("wm-floatingNav");
            html.removeClass("has-scrolled-down");
        }
    });
});
